import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { WorkflowActionInputComponent } from "./workflow.action.input.component";
import { SystemActionComponent } from "./abstract.system.action.component";

@Component({
    standalone: true,
    selector: "s25-ng-workflow-register-action",
    template: `
        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['occurrences']?.inputValue"
            (valueChange)="setInputValue('occurrences', $event)"
            [label]="'Occurrences'"
            [type]="'text'"
            [required]="true"
            [help]="'Use field variables like $CNET-123-OCCURRENCES'"
            [acceptedAnswerTypes]="acceptedFor('occurrences')"
        />
    `,
    styles: `
        .system-input {
            margin-bottom: 16px;
        }

        .system-input:last-child {
            margin-bottom: 0;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [WorkflowActionInputComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterActionComponent extends SystemActionComponent {
    protected readonly actionCode = "REGISTER" as const;
}
